import { defineStore } from "pinia";

export interface DialogConfig {
  hasTitle?: boolean;
  hasCloseButton?: boolean;
  persistent?: boolean;
  onClose?: () => unknown;
  fullscreen?: boolean;
  params?: Record<string, unknown>;
  // Path to navigate to after a successful login
  redirect?: string;
}

export const useDialog = defineStore("dialog", {
  state: () => ({
    visible: false,
    route: "/",
    config: {
      hasTitle: true,
      hasCloseButton: true,
      persistent: true,
      onClose: undefined,
      fullscreen: undefined,
      params: {},
      redirect: undefined,
    } as DialogConfig,
  }),

  actions: {
    show(route: string, config?: DialogConfig): void {
      this.route = typeof route === "string" ? route : "/";
      this.visible = true;
      this.config = { ...this.config, ...config };
    },

    hide(): void {
      if (this.config.onClose) {
        this.config.onClose();
        this.config.onClose = undefined;
      }

      this.config.fullscreen = undefined;
      this.config.redirect = undefined;
      this.visible = false;
      this.route = "/";
    },
  },
});
